import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { flatMap as _flatMap } from 'lodash';
import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { addVehicleInfoQuery } from '@amfam/policy/add-vehicle/data-access';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-amfam-vehicle-assignment-modal',
  templateUrl: './vehicle-assignment-modal.component.html',
  styleUrls: ['./vehicle-assignment-modal.component.scss'],
  standalone: false
})
export class VehicleAssignmentModalComponent implements OnInit {
  @Input() vehicleAssignmentModalId: string;
  @Input() headingMessageContent: string;
  @Input() bodyMessageContent: string;
  @Output() cancelEvent = new EventEmitter();
  @Output() switchEvent = new EventEmitter();

  modalWidth = '596';
  equalOrMoreDrivers: boolean;
  driversList$ = this.store.select(addVehicleInfoQuery.selectNewVehicleDrivers);
  vehiclesList$ = this.store.select(addVehicleInfoQuery.selectNewVehicleList);
  driverNamesList$ = this.driversList$.pipe(
    map(driverList => _flatMap(driverList, driver => driver.name))
  );

  constructor(
    private modalService: DsModalService,
    private store: Store,
    private copyService: CopyService
  ) {}

  @Input() openModal = (isOpen: boolean) => () => {
    if (isOpen) {
      this.open();
    }
  };

  ngOnInit(): void {
    this.pickContentBasedOnContext();
  }

  pickContentBasedOnContext(): void {
    combineLatest([this.driverNamesList$, this.vehiclesList$])
      .pipe(take(1))
      .subscribe(([driverNamesList, vehiclesList]) => {
        if (driverNamesList.length >= vehiclesList.length) {
          this.headingMessageContent = this.copyService.getCopy(
            'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDriversPopUpHeader'
          );
          this.bodyMessageContent = this.copyService.getCopy(
            'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDriversPopUpBody'
          );
        } else {
          this.headingMessageContent = this.copyService.getCopy(
            'policy.newVehicleDriverAssignmentHeaderFewDriversPopUpHeader'
          );
          this.bodyMessageContent = this.copyService.getCopy(
            'policy.newVehicleDriverAssignmentHeaderFewDriversPopUpBody'
          );
        }
      });
  }

  open(): void {
    this.modalService.open(this.vehicleAssignmentModalId);
  }

  close(): void {
    this.modalService.close(this.vehicleAssignmentModalId);
  }
}
